import DateRangePicker from "react-bootstrap-daterangepicker"

import moment from "moment";
import { useState } from "react";
import { useIntl } from "react-intl";
import { locale, ranges } from "../crud/Locale";

export const DataRangeFilter = (props:any) => {

  const intl = useIntl()
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(6, 'days'),
    end: moment(),
  });
  return ( <div className='row mb-3'>
    <div className='col-12'>
      <label htmlFor='date_range' className='required fw-bold fs-6'>
        {intl.formatMessage({id: 'GENERIC.CALENDAR.DATE_RANGE'})}
      </label>
      <DateRangePicker
        initialSettings={{
          locale: locale(intl),
          ranges: ranges(intl),
          alwaysShowCalendars: true,
          startDate: dateRange.start,
          endDate: dateRange.end,
          
        }}
        onApply={(event, picker) => {
          
          setDateRange({
            start: picker.startDate,
            end: picker.endDate,
          });
          props.onChangedDataRange?.(picker.startDate, picker.endDate)
        }}
      >
        <input type='text' name='date_range' id='date_range' className='form-control' />
      </DateRangePicker>
    </div>
  </div>)
}